import React from 'react'
import { Skeleton, TableCell, TableRow } from '@mui/material'

import styles from './CommunicationSnapshot.module.scss'

const RowSkeleton = ({ rows, columns }: { columns: any[]; rows: any[] }) => (
  <>
    {rows.map((placeholder, index) => (
      <TableRow data-testid="skeleton-row" key={`skeleton-row-${index + 1}`}>
        {columns.map(({ id }) => {
          if (id === 'expandConversationThread') {
            return <TableCell className={styles[id]} key={id} />
          }
          return (
            <TableCell className={styles[id]} key={id}>
              <Skeleton variant="rectangular" />
            </TableCell>
          )
        })}
      </TableRow>
    ))}
  </>
)

export default RowSkeleton
